/** @param {string | null | undefined} url */
export function extractYouTubeVideoId(url) {
  const raw = String(url || '').trim();
  if (!raw) return null;
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
    /youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/i,
    /m\.youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/i,
    /^([a-zA-Z0-9_-]{11})$/,
  ];
  for (const p of patterns) {
    const m = raw.match(p);
    if (m?.[1]) return m[1];
  }
  return null;
}

/** @param {string | null | undefined} url */
export function normalizeYouTubeWatchUrl(url) {
  const id = extractYouTubeVideoId(url);
  return id ? `https://www.youtube.com/watch?v=${id}` : null;
}
